export const getDefaultRoute = (userRole, userPermissions) => {
  const routesMapping = {
    Products: "/product-category",
    "Manage User": "/user-management/staff",
    Documents: "/company-document" || "/view-all-documents",
    "Manage Company & Member": "/company-management",
    "Delete Company & Member": "/company-management",
    "View Company & Member": "/company-management",
    Consignor: "/consignor-management",
    "Delete Consignor": "/consignor-management",
    "Manage Lots": "/lot-management",
    "Delete Lots": "/lot-management",
    "Manage Pallets": "/pallet-management" || "/createBulkPallet",
    "Delete Pallets": "/pallet-management",
    "Manage Auction": "/auction-management",
    "Delete Auction": "/auction-management",
    "View Auction": "/auction-management",
    "Global Settings": "/golbalSettings",
    "Company profile": "/company-profile",
    "Check In/Out": "/check-in-out",
    "Access Control Logs": "/entrylogs",
    "Submitted Bids": "/bid-management",
    "Manual Winner": "/bid-management/marked-winners",
    "suggested-winners": "/bid-management/suggested-winners",
    "Bidding Budget": "/bidding-budgets",
    "Consignor Settlement/Invoices": "/consignor-management/invoices/:id",
    "Manage Invoices": "/company-management/company-invoice/:id",
    "Manage Deposit": "/deposits",
    "Delete Deposit": "/deposits",
    "Loading Assignment": "/loading-management",
    Loading: "/loading",
    Reports: "/reports",
  };

  if (userRole === "Admin") {
    return "/user-management/staff";
  }

  if (["Owner", "Member", "Co-Owner"].includes(userRole)) {
    return "/company-profile";
  }

  if (userRole !== "Admin" && userPermissions.length === 0) {
    return "/dashboard";
  }

  if (userPermissions.length > 0) {
    const allowedPermissions = userPermissions.filter(perm => Object.keys(routesMapping).includes(perm.name));

    if (allowedPermissions.length > 0) {
      // Sort alphabetically
      allowedPermissions.sort((a, b) => a.name.localeCompare(b.name));
      const firstPermission = allowedPermissions[0].name;
      return routesMapping[firstPermission];
    } else {
      // User has permissions, but none mapped yet
      return "/dashboard";
    }
  }

  // Fallback
  return "/";
};
